import AGREGAR_SUB_TIPOS_OBRAS from '@/graphql/mutations/administracion/catalogos/subtiposobras/agregarSubtiposObras.gql';
import TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/tiposobras/tiposObras.gql';
import SUB_TIPOS_OBRAS from '@/graphql/querys/administracion/catalogos/subtiposobras/subTiposObras.gql';
import ACTUALIZAR_SUB_TIPO_OBRA from '@/graphql/mutations/administracion/catalogos/subtiposobras/actualizarSubtiposObras.gql';
import REMOVER_SUB_TIPO_OBRA from '@/graphql/mutations/administracion/catalogos/subtiposobras/removerSubtipoObra.gql';

export default {
  apollo: {
    tiposObras: {
      query: TIPOS_OBRAS,
    },
  },
  methods: {
    async mixAgregarSubTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_SUB_TIPOS_OBRAS,
        variables: {
          subTipoObra: this.subTipoObra,
        },
        update: (store, { data: { agregarSubtiposObras } }) => {
          const data = store.readQuery({ query: SUB_TIPOS_OBRAS });
          data.subTiposObras.push(agregarSubtiposObras);
          store.writeQuery({ query: SUB_TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarSubTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_SUB_TIPO_OBRA,
        variables: {
          id: this.subTipoObraEditar.id,
          subTipoObra: this.subTipoObra,
        },
        update: (store, { data: { actualizarSubtiposObras } }) => {
          const data = store.readQuery({ query: SUB_TIPOS_OBRAS });
          const { subTiposObras } = data;
          const index = subTiposObras
            .findIndex((subTipoObra) => subTipoObra.id
            === actualizarSubtiposObras.id);
          if (index !== -1) {
            subTiposObras.splice(index, 1, actualizarSubtiposObras);
          }
          store.writeQuery({ query: SUB_TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarSubTipoObra() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_SUB_TIPO_OBRA,
        variables: {
          id: this.subTipoObraEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: SUB_TIPOS_OBRAS });
          const { subTiposObras } = data;
          const index = subTiposObras
            .findIndex((subTipoObra) => subTipoObra.id
            === this.subTipoObraEliminar.id);
          if (index !== -1) {
            subTiposObras.splice(index, 1);
          }
          store.writeQuery({ query: SUB_TIPOS_OBRAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
